import * as Telecom from '@servicetitan/telecom-rtcs-client';
import {
  UserActivityStatus,
  UserSetAvailabilityStatus,
} from '@api/generated/graphql';
import log from './log';

export type AgentLoginStatus = {
  availabilityStatus: UserSetAvailabilityStatus;
  activityStatus: UserActivityStatus;
};

export function statusForAgentLoggedOut(): AgentLoginStatus {
  return {
    availabilityStatus: UserSetAvailabilityStatus.Offline,
    activityStatus: UserActivityStatus.None,
  };
}

export function statusForAgentLoggedIn(
  event: Pick<Telecom.AgentLoggedInEvent, 'available' | 'availabilityState'>,
): AgentLoginStatus {
  const state = event.availabilityState?.toLowerCase();
  let availabilityStatus: UserSetAvailabilityStatus;
  if (state === 'notloggedin') {
    availabilityStatus = UserSetAvailabilityStatus.Offline;
  } else if (event.available) {
    availabilityStatus = UserSetAvailabilityStatus.Available;
  } else {
    // Lossy: login has no away reason, so Away falls back to Unavailable, as in PCS.
    if (state !== 'away') {
      log(`Unexpected login availabilityState: ${event.availabilityState}`);
    }
    availabilityStatus = UserSetAvailabilityStatus.Unavailable;
  }
  return { availabilityStatus, activityStatus: UserActivityStatus.None };
}
